import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/stub384.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/music/MusicPostCard.jsx");
